import React from "react";
import Logo from "@/components/Logo";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#040810] border-t border-white/8 py-14">
      <div className="absolute inset-0 bg-grid-faint opacity-50" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <Logo className="h-11 w-11" />
            <div>
              <div className="font-display font-bold text-lg tracking-tight">HRN NETWORKS</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A0B2C6] mt-1">networking · engineering</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-[#A0B2C6] leading-relaxed max-w-md">
            Your networking solutions & application engineering partner. One platform,
            multiple solutions — designed, installed, certified and supported.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A0B2C6] mb-4">Sections</div>
          <ul className="space-y-2.5 text-sm">
            <li><a href="#services" data-testid="footer-link-services" className="text-white hover:text-[#FF6B00] transition">Services</a></li>
            <li><a href="#about" data-testid="footer-link-about" className="text-white hover:text-[#FF6B00] transition">About</a></li>
            <li><a href="#why-us" data-testid="footer-link-why-us" className="text-white hover:text-[#FF6B00] transition">Why Us</a></li>
            <li><a href="#process" data-testid="footer-link-process" className="text-white hover:text-[#FF6B00] transition">Process</a></li>
            <li><a href="#contact" data-testid="footer-link-contact" className="text-white hover:text-[#FF6B00] transition">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A0B2C6] mb-4">Get in touch</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-[#FF6B00] mt-0.5" strokeWidth={1.7} />
              <a href="tel:+919028442833" data-testid="footer-phone" className="text-white hover:text-[#FF6B00] transition">+91 90284 42833</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-[#FF6B00] mt-0.5" strokeWidth={1.7} />
              <a href="mailto:hrnnetworks@gmail.com" data-testid="footer-email" className="text-white hover:text-[#FF6B00] transition">hrnnetworks@gmail.com</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#FF6B00] mt-0.5" strokeWidth={1.7} />
              <span className="text-white">Maharashtra, India</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="section-rule max-w-7xl mx-auto my-10" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#6C84A1]">
        <span>© {new Date().getFullYear()} HRN Networks. All rights reserved.</span>
        <span className="font-mono uppercase tracking-[0.22em]">we don't just supply · we deliver solutions</span>
      </div>
    </footer>
  );
};

export default Footer;
